module.exports = __webpack_public_path__ + "img/client5.d5e488bc.png";